<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  model: {
    prop: 'showDialog',
    event: 'change:showDialog',
  },
});
</script>
<script setup lang="ts">
import FeedbackForm from '@/modules/feedback/components/FeedbackForm.vue';

withDefaults(
  defineProps<{
    showDialog?: boolean;
  }>(),
  { showDialog: true }
);

const emit = defineEmits<{
  (e: 'change:showDialog', value: boolean): void;
}>();

;

function closeDialog(): void {
  emit('change:showDialog', false);
}
</script>

<template>
  <VDialog
    v-shortkey="['esc']"
    content-class="au-popup-dialog"
    max-width="800px"
    no-click-animation
    overlay-color="secondary"
    overlay-opacity="0.80"
    persistent
    scrollable
    :value="showDialog"
    @keydown.esc="closeDialog()"
    @shortkey.native="closeDialog()"
  >
    <VCard>
      <FeedbackForm @close-dialog="closeDialog">
        <!-- card actions slot -->
        <template #cardActions="{ onSubmit }">
          <VBtn class="px-6" color="secondary" @click="closeDialog">
            {{ $t('cancelButton') }}
          </VBtn>
          <VSpacer />
          <VBtn class="px-6" color="primary" type="submit" @click="onSubmit">
            {{ $t('submitWish.button') }}
          </VBtn>
        </template>
      </FeedbackForm>
    </VCard>
  </VDialog>
</template>

<style lang="scss" scoped></style>
